import axios from 'axios';
import API_BASE_URL from '../config';

// Configurazione axios con interceptor per token
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor per aggiungere token JWT se disponibile
api.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    const userToken = localStorage.getItem('token');
    const token = adminToken || userToken;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ============ AMICI ============

/**
 * Recupera lista amici del Becco (ADMIN)
 * @param {number} adminId - ID dell'admin
 */
export const getFriends = async (adminId) => {
  const response = await api.get(`/friends?adminId=${adminId}`);
  return response.data;
};

/**
 * Alias per compatibilità
 */
export const getAllFriends = getFriends;

/**
 * Recupera inviti pendenti (ADMIN)
 * @param {number} adminId - ID dell'admin
 */
export const getPendingInvites = async (adminId) => {
  const response = await api.get(`/invites/pending?adminId=${adminId}`);
  return response.data;
};

/**
 * Recupera info sul Becco seguito (USER)
 */
export const getMyBecco = async () => {
  const response = await api.get('/friends/my-becco');
  return response.data;
};

export default {
  getFriends,
  getAllFriends,
  getPendingInvites,
  getMyBecco
};
